import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router'; 
import { ThemeManagerService } from './shared/theme-loader/theme-manager.service';
import { IconRegistryService } from './shared/icon-registry.service';
import { ToolbarComponent } from './pwa/toolbar/toolbar.component';
import { SplashComponent } from './pwa/splash/splash.component';
import { SplashAnimationType } from './pwa/splash/splash-animation-type';
import { PwaUpdateService } from './pwa/pwa-update.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  providers: [PwaUpdateService],
  imports: [RouterOutlet, ToolbarComponent, SplashComponent]
})
export class AppComponent implements OnInit {
  private readonly themeManager = inject(ThemeManagerService);
  private readonly iconRegistryService = inject(IconRegistryService);
  private readonly pwaUpdateService = inject(PwaUpdateService);

  splashAnimationType = signal<SplashAnimationType>(SplashAnimationType.FadeOut);

  constructor() {}

  ngOnInit(): void {
    this.themeManager.watchForUserPreferences();
    this.iconRegistryService.registerIcons();
  }
}
